import { HttpService } from "services";
import { RemoveTitleCompanyFunction, RemoveTitleCompanyFunctionParams } from "types/functions/removeTitleCompany";
import { AuthorizationLevel } from "types/http";

/**
 * Remove a listing
 * 
 * @throws {HttpServiceException}
 */
export const removeTitleCompany: RemoveTitleCompanyFunction = async (
  params: RemoveTitleCompanyFunctionParams
) => {
  try {
    const { titleCompanyId } = params;
    let url = `/title-company/${titleCompanyId}`;
    
    const res: boolean = await HttpService.fetch(
      url,
      {
        requestConfig: {
          method: "DELETE",
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return res;
  } catch (error) {
    throw error;
  }
};
